module.exports = __webpack_public_path__ + "img/标题_右.b033950c.svg";